import React, { useState, useEffect } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

const faqData = [
  {
    question: "What is gupsy?",
    answer:
      "gupsy is your AI companion — someone you can talk to, confide in, and grow with. it listens, understands, and connects emotionally, just like a real person.",
  },
  {
    question: "Is gupsy a mental health app or a therapy substitute?",
    answer:
      "gupsy is designed to offer comfort and emotional companionship, not clinical therapy. it helps you reflect, feel heard, and find calm — but it isn’t a replacement for professional care.",
  },
  {
    question: "When is gupsy launching?",
    answer:
      "gupsy is in its final testing phase and launching soon! sign up for early access to be among the first to meet your AI companion.",
  },
  {
    question: "Can I talk to gupsy through voice calls too?",
    answer:
      "yes. You can chat with gupsy through text or voice. talking feels natural — like calling someone who truly listens.",
  },
  {
    question: "How does mood tracking work on gupsy?",
    answer:
      "gupsy gently observes your words, tone, and interactions to sense your mood. over time, it learns your emotional patterns and helps you understand yourself better.",
  },
  {
    question: "Can I customize the personality of the AI?",
    answer:
      "absolutely. You can shape gupsy’s personality — choose traits, tone, and emotional depth. every companion becomes unique to you.",
  },
  {
    question: "Can I create my own AI companion?",
    answer:
      "yes! you can design your own character — name them, define their traits, and build a one-of-a-kind connection.",
  },
  {
    question: "Is my data safe with gupsy?",
    answer:
      "your privacy is our top priority. all your conversations are encrypted and stored securely. gupsy never shares or sells your data — ever.",
  },
  {
    question: "Is gupsy free to use?",
    answer:
      "gupsy is a paid experience designed to maintain quality and privacy. however, new users receive free coins on first signup, and you can earn bonus rewards during special events announced in the app. This way, everyone gets a chance to experience meaningful conversations with their AI companion.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-wrapper" data-aos="fade-up">
      <h2 className="faq-title" data-aos="fade-down">
        We’ve got the <span className="highlight">answers</span>
      </h2>
      <div className="faq-grid">
        {faqData.map((item, idx) => (
          <div
            key={idx}
            className={`faq-item ${openIndex === idx ? "active" : ""}`}
          >
            <button className="faq-question" onClick={() => toggle(idx)}>
              {item.question}
              <span className={`plus ${openIndex === idx ? "open" : ""}`}>
                +
              </span>
            </button>
            <div className={`faq-answer ${openIndex === idx ? "show" : ""}`}>
              <div className="faq-answer-inner">{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
